import { Component, Input } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { Globals } from '../../../../globals';
import { DishServices } from '../../../dish/services';

/**
 * Generated class for the ArticleViewColorsPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
    selector: 'page-article-view-colors',
    templateUrl: 'article-view-colors.html',
})
export class ArticleViewColorsPage {
    @Input() article: any;
    @Input() colors: any;

    constructor(public navCtrl: NavController,
        public navParams: NavParams,
        public globals: Globals,
        public dishServices: DishServices) {

    }

    setColor(color) {
        //collection name
        var collection = 'dish';
        if (this.article.type === 'product') {
            collection = 'products';
        }
        //update
        this.dishServices.afs.collection(collection).doc(this.article.UID).update({
            'pos_background_color': color.pos_background_color,
            'pos_border_color': color.pos_border_color,
            'pos_color_name': color.name,
            'updated_at': new Date(),
            'updated_user': this.globals.user_name
        });
    }
    setBackgroundColor(article) {
        return {
            'background-color': article.pos_background_color,
            'border': '1px solid ' + article.pos_border_color
        }
    }

}



// WEBPACK FOOTER //
// ./src/pages/articles/articles-view/article-view-colors/article-view-colors.ts